import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {BACKEND_MDM_URL, BACKEND_SCHEDULER_URL} from 'app/main/constants/serverConstants';
import {showMessage} from 'app/store/fuse/messageSlice';
import moment from 'moment';
import {
	EQUIPMENT_CALIBRATION,
	FIELD_ITEMS_VERIFY,
	LIMS_FIELD_ITEMS,
	TASK_CALIBRATION_STATUS,
	USER_EQUIPMENT,
	USER_FDC_FIELDS
} from './urls';
import {addToOfflineQueue} from 'offline/offlineQueueFns';
import {ActionType, EntityType} from 'offline/offlineQueueUtils';
import {updateCacheFieldItemAssigned, updateCacheFieldStatus, updateCacheVerifcationData} from 'offline/cacheFunction';

export const createEquipCalibration = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/createEquipCalibration',
	async (params, thunkApi) => {
		try {
			let data;
			const url = `${BACKEND_SCHEDULER_URL}${EQUIPMENT_CALIBRATION}`;
			if (navigator.onLine) {
				const response = await axios.post(url, params);
				data = response.data;
        // from grid action btn get status is not called so manually set cache data
        await updateCacheFieldStatus(params); 
			} else {
				data = await updateCacheFieldStatus(params);
				await addToOfflineQueue(EntityType.CALIBRATION, ActionType.VERIFY, params?.id, url, 'POST', params);        
			}

			return data;
		} catch (err) {
			const msg = err?.response?.data?.message || err?.message;
			thunkApi.dispatch(showMessage({message: `${msg}`, variant: 'error'}));
			return thunkApi.rejectWithValue(err);
		}
	}
);

export const getCalibrationStatus = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/getCalibrationStatus',
	async (params, thunkApi) => {
		try {
			const response = await axios.get(`${BACKEND_SCHEDULER_URL}${TASK_CALIBRATION_STATUS}`, {params});
			const data = await response.data;
			return data;
		} catch (err) {
			return thunkApi.rejectWithValue(err);
		}
	}
);

export const getLastCalibrationData = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/getLastCalibrationData',
	async (params, thunkApi) => {
		try {
			const response = await axios.get(`${BACKEND_SCHEDULER_URL}/api/v1/lab-equipment/${params.id}/calibration`);
			const data = await response.data;
			return data;
		} catch (err) {
			return thunkApi.rejectWithValue(err);
		}
	}
);

export const getUserFdcFields = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/getUserFdcFields',
	async (params, thunkApi) => {
		try {
			const payload = {date: moment().startOf('day').toISOString()};
			const response = await axios.get(`${BACKEND_SCHEDULER_URL}${USER_FDC_FIELDS}`, {params: payload});
			const data = await response.data;
			return data;
		} catch (err) {
			return thunkApi.rejectWithValue(err);
		}
	}
);

export const getLimsFieldItems = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/getLimsFieldItems',
	async (params, thunkApi) => {
		try {
			const response = await axios.get(`${BACKEND_SCHEDULER_URL}${LIMS_FIELD_ITEMS}`, {params});
			const data = await response.data;
			return data;
		} catch (err) {
			return thunkApi.rejectWithValue(err);
		}
	}
);

export const updateUserFieldItems = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/updateUserFieldItems',
	async (params, thunkApi) => {
		try {
			let data;
			const url = `${BACKEND_SCHEDULER_URL}${USER_EQUIPMENT}`;

			if (navigator.onLine) {
				const response = await axios.post(url, params);
				data = response.data;				
			} else {
        // TODO verified will be reset when a item assigned is replaced. That is the reason for sending getVerifiedUserFieldItems	here
				data = await updateCacheFieldItemAssigned(params);				
				await addToOfflineQueue(
					EntityType.FIELD_ITEMS,
					ActionType.FIELD_ITEMS_UPDATE,
					params?.id,
					url,
					'POST',
					params
				);

				return;
			}
			thunkApi.dispatch(
				getVerifiedUserFieldItems({
					email: params.email,
					startOfDayInUTC: moment().startOf('day').toISOString()
				})
			);

			return data;
		} catch (err) {
			const msg = err?.response?.data?.message || err?.message;
			thunkApi.dispatch(showMessage({message: msg, variant: 'error'}));
			return thunkApi.rejectWithValue(msg);
		}
	}
);

export const verifyUserFieldItems = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/verifyUserFieldItems',
	async (params, thunkApi) => {
		try {
			let data;
			const url = `${BACKEND_SCHEDULER_URL}${FIELD_ITEMS_VERIFY}`;
			if (navigator.onLine) {				
				const response = await axios.post(url, params);
				data = response.data;
			} else {				
				await addToOfflineQueue(EntityType.VERIFICATION, ActionType.VERIFY, params?.id, url, 'POST', params);				
			}
      //update cache for both online and offline. so that in offline we get the latest verified items
      await updateCacheVerifcationData(params);

			return data;
		} catch (err) {
			const msg = err?.response?.data?.message || err?.message;
			thunkApi.dispatch(showMessage({message: `${msg}`, variant: 'error'}));
			return thunkApi.rejectWithValue(err);
		}
	}
);

export const getVerifiedUserFieldItems = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/getVerifiedUserFieldItems',
	async (params, thunkApi) => {
		try {
			const response = await axios.get(`${BACKEND_SCHEDULER_URL}${FIELD_ITEMS_VERIFY}`, {params});
			const data = await response.data;
			return data;
		} catch (err) {
			const msg = err?.response?.data?.message || err?.message;
			thunkApi.dispatch(showMessage({message: `${msg}`, variant: 'error'}));
			return thunkApi.rejectWithValue(err);
		}
	}
);
